module.exports = __webpack_public_path__ + "images/landing/banner/help-img-9.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/banner/help-img-9.png
// module id = EHgq
// module chunks = 153